import React from "react";
import useStyles from './styles';

const GridFlex = ({ children, ...props }) => {
  const { header } = useStyles(props);
  return <div className={header}>{children}</div>;
};

export default GridFlex;
